<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import GroupDetail from '../../../../groups/components/GroupDetail.vue'
import { GroupID } from '../../../../groups/models/group'

definePage({
    props: true,
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        childNavItems: [
            {
                label: 'Business',
                route: '/(app)/settings/business/',
            },
            {
                label: 'Buildings',
                route: '/(app)/settings/buildings/',
            },
            {
                label: 'Skills',
                route: '/(app)/settings/skills/',
            },
            {
                label: 'Groups',
                route: '/(app)/settings/groups/',
            },
            {
                label: 'Shift Reasons',
                route: '/(app)/settings/shift-reasons/',
            },
        ],
    }
})

const {
  id,
} = defineProps<{
    id: GroupID
}>()
</script>

<template>
  <GroupDetail
    :id="id"
  />
</template>